import { Routes, Route } from "react-router-dom";
import Home from "../screens/home";
import Coaching from "../screens/coaching";
// import EditingBoard from '../screens/editingBoard';
import LoginPage from '../screens/login';
import Register from '../screens/register';
import DesignActivityBoard from '../screens/designActivityBoard';
import DesignClassBoard from '../screens/designClassBoard';
import DesignAssessBoard from '../screens/designAssessBoard';
import Chart from '../screens/chart';
import Profile from '../screens/profile';
import RecoveryPassword from '../screens/recoveryPassword';
import ChangePassword from '../screens/changePassword';
import DesignABP from '../screens/designABP';
import InteractionABP from '../screens/interactionABP';
import EditingABPBoard from '../screens/editingABPBoard';
import NotionPrinciplesPage from '../screens/principles';
import GoogleRegister from '../screens/googleRegister';
import ConfirmEmail from '../screens/confirmEmail';
import RegisterHubspot from '../screens/registerHubspot';
import DesignRubricBoard from '../screens/designRubricBoard';
import DesignContextBoard from '../screens/designContextBoard';
import LoginPageInstitutional from '../screens/loginInst';
import DesignWarmUpBoard from '../screens/designWarmUpBoard';
import Admin from '../screens/admin';
import Institution from '../screens/admin/institution';
import SuperPower from '../screens/admin/superPower';
import CourseProfile from '../screens/courseProfiles';
import DesignBloomPerformanceBoard from '../screens/designBloomPerformanceBoard';
import ClassProfile from '../screens/admin/classProfile';


function AppRouter() {
  return (
    <Routes>
      <Route path="/" exact element={<Home />} />
      <Route path="/admin" exact element={<Admin />}>
        <Route path="/admin/super-power" element={<SuperPower />} />
        <Route path="/admin/institution" element={<Institution />} />
        <Route path="/admin/class-profile" element={<ClassProfile />} />
      </Route>
      <Route path="/confirmation" exact element={<ConfirmEmail />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/onboarding-teacher" element={<LoginPageInstitutional />} />
      <Route path="/register" element={<Register />} />
      <Route path="/register-google" element={<GoogleRegister />} />
      <Route path="/register-hubspot" element={<RegisterHubspot />} />
      <Route path="/recovery-password" element={<RecoveryPassword />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path="/chart" element={<Chart />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/design-activity" element={<DesignActivityBoard />} />
      <Route path="/design-class" element={<DesignClassBoard />} />
      <Route path="/design-assess" element={<DesignAssessBoard />} />
      <Route path="/design-rubric" element={<DesignRubricBoard />} />
      <Route path="/design-context" element={<DesignContextBoard />} />
      <Route path="/design-startup-dynamic" element={<DesignWarmUpBoard />} />
      <Route
        path="/design-performances-and-evidence-bloom"
        element={<DesignBloomPerformanceBoard />}
      />
      <Route path="/editing-abp-board" element={<EditingABPBoard />} />
      <Route path="/shaia-coaching" element={<Coaching />} />
      <Route path="/design-abp" element={<DesignABP />} />
      <Route path="/interation-abp" element={<InteractionABP />} />
      <Route path="/principles" element={<NotionPrinciplesPage />} />
      <Route path='/course-profile' element={<CourseProfile />} />
    </Routes>
  );
}

export default AppRouter;
